import CompanyHeader from '../vara-haften/CompanyHeader'
import CompanyModalCoupon from '../vara-haften/CompanyModalCoupon'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

const CompanyReviewCoupons = ({ companyReviewData, companyTypesData, booklet }) => {

  const validTo = new Date(booklet?.validTo).toLocaleDateString('sv-SE', { day: 'numeric', month: 'numeric' }) || '';

  return (
    <div className="company-review-booklet box flex flex-col items-center">
      {booklet &&
        <div className="company-review-booklet-header relative flex flex-col items-center">
          <div className='booklet-bg left' style={{ backgroundColor: booklet?.colorLeft }} />
          <div className='booklet-bg right' style={{ backgroundColor: booklet?.colorRight }} />
          <img src={REACT_APP_IMAGE_BASE_URL + booklet?.logoURL} alt={booklet?.title} />
          <h3 style={{ color: booklet?.colorFont || '#fff' }}>{booklet?.title}</h3>
          <small style={{ color: booklet?.colorFont || '#fff' }}>Giltigt t.o.m {validTo}</small>
        </div>
      }
      <div className="relative company-review-coupons box">
        <CompanyHeader
          company={companyReviewData?.bookletCompanyReviewByToken?.company}
          companyType={companyTypesData?.types[companyReviewData?.bookletCompanyReviewByToken?.company?.typeId]}
        />
        {companyReviewData?.bookletCompanyReviewByToken?.coupons
          .filter(c => c !== null)
          .sort((c1, c2) => (c1?.position || 0) - (c2?.position || 0))
          .map(coupon =>
            <CompanyModalCoupon
              key={coupon._id}
              coupon={coupon}
              booklet={booklet}
              isReview
            />
          )}
      </div>
    </div>
  )
}

export default CompanyReviewCoupons
